import React from 'react';
import { Link } from 'react-router-dom';
import { useI18n } from '../i18n';
import PageHero from '../components/PageHero';
import HighlightPhrase from '../components/HighlightPhrase';
import { SectionWrap, SectionHeader, Bullets, TitledBullets, Prose } from '../components/SectionPrimitives';

import { VIDAT_IMG } from '../lib/images';

const IMG = VIDAT_IMG.monasterio1;

const Rehabilitacion = () => {
  const { content } = useI18n();
  const r = content.rehab;
  const buttons = content.buttons;
  return (
    <main data-testid="rehab-page">
      <PageHero eyebrow={r.eyebrow} title={r.title} lead={r.lead} image={IMG} testId="rehab-hero" />

      <SectionWrap bg="ivory">
        <Prose paragraphs={[r.lead2]} />
      </SectionWrap>

      <SectionWrap testId="rehab-forwhom">
        <SectionHeader title={r.forWhomTitle} />
        <p className="text-stone-700 font-light max-w-3xl mb-6">{r.forWhomLead}</p>
        <p className="text-stone-700 font-light max-w-2xl mb-6">{r.forWhomIntro}</p>
        <Bullets items={r.forWhom} />
        <p className="mt-8 text-stone-700 font-light max-w-3xl leading-relaxed">{r.forWhomOutro}</p>
      </SectionWrap>

      <SectionWrap bg="ivory" testId="rehab-problem">
        <SectionHeader title={r.problemTitle} />
        <Prose paragraphs={[r.problemP1, r.problemP2, r.problemP3, r.problemP4]} />
      </SectionWrap>

      <SectionWrap testId="rehab-val">
        <SectionHeader title={r.valTitle} />
        <Prose paragraphs={[r.valP1, r.valP2]} />
        <div className="mt-8"><Bullets items={r.valList} /></div>
        <p className="mt-8 text-stone-700 font-light max-w-3xl leading-relaxed">{r.valOutro}</p>
      </SectionWrap>

      <SectionWrap bg="ivory" testId="rehab-adapt">
        <SectionHeader title={r.adaptTitle} />
        <Prose paragraphs={[r.adaptP1, r.adaptP2, r.adaptP3]} />
        <div className="mt-8"><TitledBullets items={r.adaptModes} /></div>
        <p className="mt-8 text-stone-700 font-light max-w-3xl leading-relaxed">{r.adaptOutro}</p>
      </SectionWrap>

      <SectionWrap testId="rehab-work">
        <SectionHeader title={r.workTitle} />
        <Prose paragraphs={[r.workP1, r.workP2]} />
        <div className="mt-8"><TitledBullets items={r.workList} /></div>
      </SectionWrap>

      <HighlightPhrase dark testId="rehab-highlight">
        {r.workHighlight}
      </HighlightPhrase>

      <SectionWrap bg="ivory" testId="rehab-follow">
        <SectionHeader title={r.followTitle} />
        <Prose paragraphs={[r.followP1, r.followP2]} />
        <div className="mt-8"><Bullets items={r.followList} /></div>
        <p className="mt-8 text-stone-700 font-light max-w-3xl leading-relaxed">{r.followOutro}</p>
      </SectionWrap>

      <SectionWrap testId="rehab-obtain">
        <SectionHeader title={r.obtainTitle} />
        <Bullets items={r.obtain} />
        <div className="mt-12">
          <Link to="/programar-visita" className="btn-primary" data-testid="rehab-cta-join">
            {buttons.joinList}
          </Link>
        </div>
      </SectionWrap>

      <SectionWrap bg="ivory" testId="rehab-model">
        <SectionHeader title={r.modelTitle} />
        <Prose paragraphs={[r.modelP1, r.modelP2]} />
      </SectionWrap>

      <SectionWrap testId="rehab-integrated">
        <SectionHeader title={r.integratedTitle} />
        <Prose paragraphs={[r.integratedP1, r.integratedP2]} />
      </SectionWrap>

    </main>
  );
};

export default Rehabilitacion;
